import {
  Button, Card, Stack, Title, Text, Center, ThemeIcon,
} from "@mantine/core";
import { IconLock, IconRefresh, IconLogout } from "@tabler/icons-react";
import { useAuth } from "../../../shared/auth";

/**
 * Garson (ve kasa açma yetkisi olmayan roller) için: şubede henüz açık kasa
 * yokken gösterilen bilgi ekranı. Kasayı kasiyer/yönetici açar; garson kasayı
 * açamaz (nakit satış açık kasa olmadan ledger'a yazılamaz). Kasa açılınca
 * "Tekrar Dene" ile sipariş ekranına geçer.
 */
export function ShiftClosedNotice({ onRetry }: { onRetry: () => void }) {
  const { user, logout } = useAuth();
  return (
    <Center h="100vh" bg="gray.0" p="md">
      <Card padding="xl" radius="lg" withBorder shadow="md" w="100%" maw={420}>
        <Stack gap="lg" align="center">
          <ThemeIcon size={64} radius="xl" color="gray" variant="light">
            <IconLock size={36} />
          </ThemeIcon>
          <Stack gap={4}>
            <Title order={3} ta="center">
              Kasa henüz açılmadı
            </Title>
            <Text c="dimmed" ta="center" size="sm">
              Merhaba {user?.username}. Sipariş alabilmek için şubenin kasasının
              açık olması gerekiyor. Lütfen kasiyer veya yöneticiden kasayı
              açmasını isteyin, sonra "Tekrar Dene"ye dokunun.
            </Text>
          </Stack>

          <Button
            fullWidth
            size="lg"
            leftSection={<IconRefresh size={20} />}
            onClick={onRetry}
          >
            Tekrar Dene
          </Button>
          <Button
            fullWidth
            variant="light"
            color="red"
            leftSection={<IconLogout size={18} />}
            onClick={logout}
          >
            Çıkış Yap
          </Button>
        </Stack>
      </Card>
    </Center>
  );
}
